import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChartModule } from 'primeng/chart';
import { TeamsService } from '../../../services/teams.service';
import { ITeamStatus } from '../../../_interfaces/teamStatus';
import { RouterLink } from '@angular/router';
import { ChartOptions } from 'chart.js';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-team-status-widget',
  standalone: true,
  imports: [ CommonModule, ChartModule, RouterLink, TranslatePipe ],
  templateUrl: './team-status-widget.component.html',
  styleUrls: ['./team-status-widget.component.scss'],
  providers: [TeamsService]
})
export class TeamStatusWidgetComponent implements OnInit {
  teamStatuses: ITeamStatus[] = [];
  isLoading: boolean = true;
  errorMessage: string | null = null;

  constructor(private teamsService: TeamsService) { }

  ngOnInit(): void {
    this.fetchTeamStatuses();
  }

  fetchTeamStatuses(): void {
    this.isLoading = true;
    this.errorMessage = null;
    this.teamsService.getTeamsStatus().subscribe({
      next: (data) => {
        this.teamStatuses = data;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error fetching team statuses:', error);
        this.errorMessage = 'Failed to load team statuses. Please try again later.';
        this.isLoading = false;
      }
    });
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Understaffed':
        return 'status-understaffed';
      case 'Balanced':
        return 'status-balanced';
      case 'Overstaffed':
      case 'Mixed Workforce':
        return 'status-mixed';
      default:
        return 'status-undefined';
    }
  }

  getChartData(staffingPercentage: number): any {
    let color = '#28a745'; // Balanced (Green)
    if (staffingPercentage < 70) {
      color = '#dc3545'; // Understaffed (Red)
    } else if (staffingPercentage > 100) {
      color = '#ffc107'; // Overstaffed/Mixed (Yellow/Amber)
    }

    return {
      labels: ['Staffed', 'Remaining'],
      datasets: [
        {
          data: [staffingPercentage, Math.max(0, 100 - staffingPercentage)],
          backgroundColor: [color, '#e9ecef'],
          hoverBackgroundColor: [color, '#e9ecef'],
          borderColor: 'transparent'
        }
      ]
    };
  }

  getChartOptions(): ChartOptions<'doughnut'> {
    return {
      cutout: '60%', // doghnut widthness
      responsive: true,
      maintainAspectRatio: true, 

      plugins: {
        legend: {display: false},
        tooltip: {enabled: false},
        datalabels: { display: false }
      },
      animation: {
        animateRotate: true,
        animateScale: true
      },
      
    };
  }
}